import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WalletIcon from "@mui/icons-material/Wallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SettingsIcon from "@mui/icons-material/Settings";
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { ReplayCircleFilled } from "@mui/icons-material";

const logOut = (e) => {
  e.preventDefault();
  localStorage.clear();
  window.location.reload();
  // navigate("/dashboard", { replace: true });
};
export const mainListItems = (
  <React.Fragment>
    <ListItemButton component={Link} to="/dashboard">
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>
    <ListItemButton component={Link} to="/wallet">
      <ListItemIcon>
        <WalletIcon />
      </ListItemIcon>
      <ListItemText primary="My Wallet" />
    </ListItemButton>
    <ListItemButton component={Link} to="/transaction">
      <ListItemIcon>
        <ReceiptLongIcon />
      </ListItemIcon>
      <ListItemText primary="Transaction" />
    </ListItemButton>
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset></ListSubheader>
    <ListItemButton component={Link} to="/setting">
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary="Settings" />
    </ListItemButton>
    <ListItemButton component={Link} to="/help">
      <ListItemIcon>
        <ReportOutlinedIcon />
      </ListItemIcon>
      <ListItemText primary="Help" />
    </ListItemButton>
    <ListItemButton onClick={logOut}>
      <ListItemIcon>
        <LogoutRoundedIcon />
      </ListItemIcon>
      <ListItemText primary="Log out" />
    </ListItemButton>
  </React.Fragment>
);